<template>
	<div>
		<div class="md-layout">
			<entity-card v-bind="{ schema, readEntity, deleteEntity, createEntity, updateEntity, swipeText, swipeFunction, extendedButtons }" :entity.sync="entity" @openModal="showModal = true"></entity-card>
		</div>

		<modal v-if="showModal" @close="showModal = false">
			<template slot="body">
				<h4 class="title"> Alterar senha</h4>
				<md-field>
					<label>Nova senha</label>
					<md-input v-model="newPassword" type="password" v-validate="'required'"></md-input>
				</md-field>
			</template>
			<template slot="footer">
				<md-button class="md-accent" style="margin: 5px" @click="changePassword()">Alterar</md-button>
				<md-button class="md-danger" @click="showModal = false">Cancelar</md-button>
			</template>
		</modal>
	</div>
</template>

<script>
	import Admin from "@/models/admin.model.vue"
	import EntityCard from "@/components/Espresso/EntityCard.vue"
	import EspressoAux from "@/components/Espresso/EspressoAux.vue"
	import { Modal } from "@/components"

	export default {
		components: {
			EntityCard,
			Modal,
		},
		data() {
			return {
				entity: {
					id: this.$route.params.id,
				},
				extendedButtons: [{
					func: 'openModal',
					name: "Alterar senha",
				}],
				schema: Admin.getSchema(),
				swipeText: null,
				showModal: false,
				newPassword: "",
			}
		},
		methods: {
			async readEntity(entityId) {
				return Admin.getInfo(entityId);
			},
			async deleteEntity(entityId) {
				await Admin.remove(entityId);
				if (this.entity.role === "ADMIN") {
					this.$router.push(`/administradores`);
				} else if (this.entity.role === "USER") {
					this.$router.push(`/usuarios`);
				}
			},
			async updateEntity(entity) {
				const dataToUpdate = Object.assign({}, entity);
				delete dataToUpdate.role;
				return Admin.updateInfo(dataToUpdate);
			},
			async createEntity(entity) {
				this.entity = await Admin.create(entity);
				this.$router.replace(`/administrador/${this.entity.id}`);
				return this.entity;
			},
			async swipeFunction(value) {
				return Admin.swipeStatus(this.entity.id, value);
			},
			async changePassword() {
				const validation = await this.$validator.validateAll();
				this.showModal = false;

				if (!validation) {
					EspressoAux.showFailModal("Preencha uma nova senha.", "Erro", () => this.showModal = true);
				} else {
					EspressoAux.executeAsync(async () => {
						Admin.changePassword(this.entity.id, this.newPassword);
					}, "Senha alterada.", "Erro ao alterar senha.");
					this.newPassword = "";
				}
			}
		},
		mounted() {
			if (this.entity.id && this.entity.id !== "novo") {
				EspressoAux.executeAsync(async () => {
					this.localEntity = await this.readEntity(this.entity.id);
					if (this.localEntity.role === "USER") this.swipeText = "Ativar/Suspender Usuário";
				}, null, "Erro ao carregar informações!");
			}
		},
	};
</script>
